module.exports = __webpack_public_path__ + "img/small_certificate.5c4ec7d8.png";